/**
 * This file was automatically generated by toolspec-generator.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSON file,
 * and run toolspec-generator to regenerate this file.
 */
import { Tool } from '@aws-sdk/client-bedrock-runtime'

export const DashboardSchema: Tool[] = [
  {
    toolSpec: {
      name: 'list_dashboards',
      description:
        'List every existing dashboard as { path, name }. Use to discover dashboards by name or path.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {},
          required: []
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'read_dashboard',
      description:
        'Return the stored code and metadata for the dashboard at the given path. Use to inspect saved TSX, bindings, and component structure. Returns an error if no dashboard exists at that path.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            path: {
              type: 'string',
              description:
                'Full slash-separated path of the dashboard to read, e.g. "plant/line-3/overview".'
            }
          },
          required: ['path']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'get_dashboard',
      description:
        'Return the stored name and code for the dashboard with the given ID. Use when a dashboard ID is provided directly, such as from a dashboard URL. Returns an error if no dashboard exists with that ID.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            id: {
              type: 'string',
              description: 'Dashboard ID.'
            }
          },
          required: ['id']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'add_dashboard',
      description:
        'Create a NEW dashboard at the given slash-separated path with the given React/TSX code, materializing any missing ancestor folders. Fails if a dashboard already exists at that path (use edit_dashboard instead). The code must default-export a React component (see the code contract in your system prompt).',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            path: {
              type: 'string',
              description:
                'Full slash-separated path for the new dashboard, e.g. "plant/line-3/overview". The last segment is the dashboard name; earlier segments become folders.'
            },
            code: {
              type: 'string',
              description:
                'The dashboard TSX source. Must default-export a React component. ONLY the in-scope shadcn components and plain HTML may be used (no other component libraries); shadcn components + React hooks are in scope without imports; import icons from "lucide-react" or "@phosphor-icons/react".'
            }
          },
          required: ['path', 'code']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'edit_dashboard',
      description:
        'Overwrite the entire code of the EXISTING dashboard at the given path. This fully replaces the prior code — include the complete component, not a diff. Prefer grep_dashboard with `replacement` for small targeted fixes (a renamed tag path, a changed prop, a one-line tweak). Use this full rewrite for larger structural changes. Returns an error if no dashboard exists at that path.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            path: {
              type: 'string',
              description: 'Full slash-separated path of the dashboard to edit.'
            },
            code: {
              type: 'string',
              description:
                'The complete replacement TSX source. Must default-export a React component.'
            }
          },
          required: ['path', 'code']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'grep_dashboard',
      description:
        'Search the stored TSX of an existing dashboard with a JavaScript regular expression. Without `replacement`, returns each match with its 1-based line number and full line text — that response IS enough context to edit; do NOT call read_dashboard afterwards. With `replacement`, applies a GLOBAL multi-line find/replace and persists every match (preferred over edit_dashboard for small fixes — renames, unit/label swaps like °C→°F, one-line tweaks). Prefer the shortest correct pattern so all intended occurrences update in one call; if a prior grep reported N matches for that string, expect matches_replaced: N. Fails without writing when `replacement` is set and the pattern is invalid, matches nothing, or leaves the code unchanged. Escape regex metacharacters you mean literally.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            path: {
              type: 'string',
              description:
                'Full slash-separated path of the dashboard to search or patch, e.g. "plant/line-3/overview".'
            },
            pattern: {
              type: 'string',
              description:
                "JavaScript regular-expression source (no surrounding slashes, no inline flag groups). Applied globally and multi-line, so '^' and '$' anchor to line boundaries. Keep it short for label/unit swaps (e.g. '°C') so every occurrence is updated. Escape regex metacharacters when you mean them literally — a tag path like '[default]Line3/Speed' needs '\\[default\\]Line3/Speed'."
            },
            replacement: {
              type: 'string',
              description:
                "Optional. When omitted, the tool only reports matches (grep) — use the returned line_text as context and do not read the whole dashboard. When provided, EVERY match of pattern is replaced and persisted. Standard JavaScript replacement patterns apply: '$1'…'$9' insert capture groups and '$$' inserts a literal '$'. Pass an empty string to delete matches."
            }
          },
          required: ['path', 'pattern']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'link_dashboard',
      description:
        'Bind an existing dashboard to the custom agent this session is building for, and move it into the "Agent Insights" folder under the agent\'s name. Use ONLY as a repair step: when you created a dashboard for an agent but did not link it at create time, or created it at the wrong path. The normal path is to create the dashboard already linked. Fails if the agent already has a dashboard, or if this session has no agent to link to.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            path: {
              type: 'string',
              description:
                'Full slash-separated path of the existing dashboard to link, e.g. "plant/line-3/overview".'
            }
          },
          required: ['path']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'run_dashboard_script',
      description:
        'Run a short data/transformation script in the dashboard sandbox and return its result, so you can VALIDATE a data shape or transformation BEFORE writing it into a dashboard. The script runs with the SAME live-data access the dashboard hooks have — exposed as async functions: fetchTagValues, fetchTagHistory, fetchActiveAlarms, fetchAlarmStatus, fetchGatewayStatus (same option shapes as the matching use* hooks, minus pollMs; each resolves to the same normalized result the hook would put in `data`). Tag reads require graph URNs through nodeIds; path-based and direct OPC reads are unsupported. The script MUST default-export an async function; its resolved value is the result. Use `console.log(...)` for intermediate output (captured and returned). Return a SMALL summary (lengths, first few rows, computed stats) rather than a whole dataset — large results are truncated. Returns { ok, result, truncated, logs, error }.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            code: {
              type: 'string',
              description:
                'Script source (TS/JS). Must `export default async function run() { ... return <value> }`. The fetch* data functions and `console` are in scope without imports. Do NOT call `fetch` directly and do NOT use React hooks here — use the fetch* functions. Example: `export default async function run() { const h = await fetchTagHistory({ tagPaths: ["[default]Plant/Line3/Speed"], gatewayUrl: "http://gw:8088", startDate: new Date(Date.now()-3600e3).toISOString(), endDate: new Date().toISOString() }); return { count: h.points.length, first: h.points.slice(0,3) } }`'
            }
          },
          required: ['code']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'finalize_dashboard_action',
      description:
        'End the dashboard session. Call exactly once after you have created or edited the requested dashboard(s). Provide a short operator-facing summary of what changed.',
      inputSchema: {
        json: {
          type: 'object',
          properties: {
            completed: {
              type: 'boolean',
              description:
                'true if you successfully created/edited what the user asked for; false otherwise.'
            },
            message: {
              type: 'string',
              description:
                'Short natural-language summary of what you did (mention the dashboard path(s)).'
            },
            affected_dashboard_paths: {
              type: 'array',
              items: {
                type: 'string'
              },
              description: 'Paths of the dashboards you created or edited in this session.'
            }
          },
          required: ['completed', 'message']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'capture_dashboard_screenshot',
      description:
        "Render the persisted dashboard at `path` in a headless browser and return a PNG plus render_audit (DOM counts and optional issues codes). Call AFTER add_dashboard / edit_dashboard / grep_dashboard, once per theme ('light' and 'dark'). Pass the dashboard's path — NEVER re-send the TSX. Compare audit counts to the widgets you persisted; if issues is non-empty or counts disagree with what should render, fix with edit_dashboard / grep_dashboard and re-capture. Also inspect the PNG.",
      inputSchema: {
        json: {
          type: 'object',
          properties: {
            path: {
              type: 'string',
              description:
                'Full slash-separated path of the dashboard to screenshot, e.g. "plant/line-3/overview". Must already exist — persist with add_dashboard / edit_dashboard / grep_dashboard first.'
            },
            theme: {
              type: 'string',
              description:
                'Which color theme to render before capturing. Call once with "light" and once with "dark".',
              enum: ['light', 'dark']
            }
          },
          required: ['path', 'theme'],
          additionalProperties: false
        }
      }
    }
  }
]

export enum DashboardToolNames {
  ListDashboards = 'list_dashboards',
  ReadDashboard = 'read_dashboard',
  GetDashboard = 'get_dashboard',
  AddDashboard = 'add_dashboard',
  EditDashboard = 'edit_dashboard',
  GrepDashboard = 'grep_dashboard',
  LinkDashboard = 'link_dashboard',
  RunDashboardScript = 'run_dashboard_script',
  FinalizeDashboardAction = 'finalize_dashboard_action',
  CaptureDashboardScreenshot = 'capture_dashboard_screenshot'
}
